<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="field.fieldId"
    :rules="validator"
  >
    <div
      v-if="isVisible"
      class="space-top-sm"
      :class="{ 'has-error': errors.length }"
    >
      <label class="form-field--label">{{ field.title }}</label>

      <component
        :is="fieldType"
        v-model="fieldValue"
        :class="{ 'has-error': errors.length }"
        :name="field.fieldId"
        v-bind="fieldComponent"
        :options="fieldOptions"
        :has-error="errors.length >= 1"
        :name-field-type="field.nameFieldType"
        class="form-field--input"
      ></component>

      <span v-if="errors.length" class="text-danger">
        {{ $t('login.requiredField') }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
  import fields from './fields'

  import services from '../services'

  import { ValidationProvider } from 'vee-validate'

  export default {
    components: { ...fields, ValidationProvider },
    props: ['field', 'value'],
    data() {
      return {
        fieldValue: ''
      }
    },
    computed: {
      fieldType() {
        const type = this.field.type || this.field.fieldType

        return services.getFieldTypes()[type]
      },
      fieldComponent() {
        return {
          id: this.field.fieldId,
          name: this.field.fieldId,
          title: this.field.title
        }
      },
      fieldOptions() {
        if (this.field.listItem) {
          return this.field.listItem
        }

        return undefined
      },
      isVisible() {
        return this.field.isClientVisible
          ? this.field.isClientVisible.value
          : true
      },
      validator() {
        const rules = services.getFieldRules()

        let fieldRules = rules[this.field.type || this.field.fieldType] || {}

        fieldRules['required'] =
          this.isVisible &&
          ((this.field.isMandatory && this.field.isMandatory.value) ||
            this.field.required)

        return fieldRules
      }
    },
    watch: {
      fieldValue() {
        this.$emit('input', this.fieldValue)
      }
    },
    updated() {
      if (this.value && !this.fieldValue) {
        this.fieldValue = this.value
      }
    },
    created() {
      this.fieldValue = ''
    }
  }
</script>

<style>
  .form-field--label {
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
  }

  .form-field--input {
    border-radius: 34.5px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #979797;
    background: #fff;
    color: #757578;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin-bottom: 6px;
  }
</style>
